import _ from "lodash";

export const refundApplicationStatusObjects = [
    { id: 'draft', name: 'Brouillon', bStyle: 'default' },
    { id: 'ongoing', name: "Enregistré", bStyle: 'primary' },
    { id: 'updated', name: "Mis à jour", bStyle: 'primary' },
    { id: 'questioned', name: 'Compléments attendus', bStyle: 'warning' },
    { id: 'controlled', name: 'Décision attendue', bStyle: 'primary' },
    { id: 'accepted', name: 'Accepté', bStyle: 'primary' },
    { id: 'refused', name: 'Refusé', bStyle: 'danger' },
    { id: 'closed', name: 'Clos', bStyle: 'success'},
]

// Formes d'aide proposées en décision fonds de secours, par unité de la sollicitation (dans l'ordre d'affichage)
// TODO métier : « Avance remboursable » est toujours proposée pour le type €, à revoir si l'association n'a pas de libéralité en cours
export const reliefFundFormLabels = {
    advanceOnLegacy: 'Avance remboursable',
    directAssociationPayment: 'Directe association',
    thirdPartyDirectPayment: 'Directe tiers'
}

export const reliefFundFormsByUnit = {
    euro: ['advanceOnLegacy', 'directAssociationPayment', 'thirdPartyDirectPayment'],
    kilogram: ['directAssociationPayment']
}

export const organizationStatusObjects = [
    { id: 'member', name: 'Membre' },
    { id: 'suspended', name: 'Suspendue' },
    { id: 'struckOff', name: 'Radiée de la CNDA' },
    { id: 'resigned', name: 'Démissionnaire' },
    { id: 'ceasedOperations', name: 'Cessation d’activité' },
    //{ id: 'target', name: 'Cible' },
]

export const establishmentStatusObjects = [
    { id: 'headquarters', name: 'Siège' },
    { id: 'secondary', name: 'Secondaire' },
    { id: 'closed', name: 'Fermé' }
]

export const reliefFundPaymentStatusObjects = [
    { id: 'ongoing', name: "Validation attendue", bStyle: 'primary' },
    { id: 'validated', name: "Validé", bStyle: 'success' },
    { id: 'incomplete', name: "Justification attendue", bStyle: 'warning' },
    { id: 'refused', name: "Refusé", bStyle: 'danger' },
    { id: 'draft', name: "Brouillon", bStyle: 'default' }
]

export const adhesionApplicationStatusObjects = [
    { id: 'filed', name: 'Volet Institutionnel : Enregistré', bStyle: 'primary'},
    { id: 'incomplete', name: 'Volet Institutionnel : Compléments  demandés', bStyle: 'warning' },
    { id: 'updated', name: 'Volet Institutionnel : Mis à jour', bStyle: 'primary' },
    { id: 'preValidated', name: 'Volet Institutionnel : Validé', bStyle: 'warning' },

    { id: 'filed2', name: 'Volet Administratif : Enregistré', bStyle: 'primary' },
    { id: 'incomplete2', name: 'Volet Administratif : Compléments  demandés', bStyle: 'warning' },
    { id: 'updated2', name: 'Volet Administratif : Mis à jour', bStyle: 'primary' },
    { id: 'validated2', name: 'Volet Administratif : Validé', bStyle: 'primary' },

    { id: 'filed3', name: 'Volet Sanitaire : Enregistré', bStyle: 'primary' },
    { id: 'incomplete3', name: 'Volet Sanitaire : Compléments  demandés', bStyle: 'warning' },
    { id: 'updated3', name: 'Volet Sanitaire : Mis à jour', bStyle: 'primary' },

    { id: 'completed', name: 'Conformité des 3 volets : Validée', bStyle: 'primary' },

    { id: 'visitInProgress', name: 'Visite : Demandée', bStyle: 'warning' },
    { id: 'visitValidated', name: 'Avis consultatif : Favorable', bStyle: 'primary' },
    { id: 'visitRejected', name: 'Avis consultatif : Défavorable', bStyle: 'danger' },

    { id: 'accepted', name: 'Adhésion : Acceptée', bStyle: 'primary' },
    { id: 'rejected', name: 'Adhésion : Refusée', bStyle: 'danger' },
    { id: 'validated', name: 'Adhésion : Validée', bStyle: 'success' },
]

export const liberalityApplicationStatusObjects = [
    { id: 'draft', name: 'Brouillon', bStyle: 'warning'},
    { id: 'incomplete', name: 'Ajournement', bStyle: 'warning'},
    { id: 'readyToBePresented', name: 'À présenter', bStyle: 'primary'},
    { id: 'updated', name: 'À représenter', bStyle: 'primary'},
    { id: 'awaitingDecision', name: 'Décision attendue', bStyle: 'primary'},
    { id: 'validated', name: 'Acceptation', bStyle: 'success'},
    { id: 'rejected', name: 'Renonciation', bStyle: 'danger'},
    { id: 'abandoned', name: 'Abandon', bStyle: 'danger'},
    { id: 'revision', name: 'Révision', bStyle: 'warning'},
    { id: 'closed', name: 'Clos', bStyle: 'default'},
    { id: 'reopened', name: 'Rouvert', bStyle: 'primary'},
]

export const liberalityReversionRecordStatusIds = ['abandoned', 'validated', 'closed', 'revision', 'rejected', 'reopened']

export const liberalityReversionRecordStatusObjects = liberalityReversionRecordStatusIds.map(id => liberalityApplicationStatusObjects.find(status => status.id === id))

export const liberalityReceivableStatusObjects = [
    { id: 'ongoing', name: 'En cours' },
    { id: 'settled', name: 'Réglé' },
    { id: 'abandoned', name: 'Abandonné' },
    { id: 'contested', name: 'Contesté' },
]

export const liberalitySolicitationStatusObjects = [
    { id: 'proposed', name: 'Proposé' },
    { id: 'accepted', name: 'Accepté' },
    { id: 'rejected', name: 'Rejeté' },
]

export const newOrganizationActivities = [
    { id: 'adoption', name: 'Adoption', nameExt: 'Adoption'}, //adoption
    { id: 'pound', name: 'Fourrière', nameExt: 'Fourrière'},
    { id: 'pension', name: 'Pension', nameExt: 'Pension'},
    { id: 'retirement', name: 'Retraite - sanctuaire', nameExt: 'Retraite - sanctuaire'},
    { id: 'hostFamily', name: "Famille d'accueil", nameExt: "Devenir famille d'accueil"},
    { id: 'wildlife', name: "Centre de soins pour la faune sauvage", nameExt: 'Centre de soins pour la faune sauvage'},
    { id: 'strayCat', name: "Protection des chats libres", nameExt: 'Protection des chats libres'},
    { id: 'other', name: 'Autre', nameExt: 'Autre'},
]

export const OTHER_ACTIVITY_ID = 'other'

export const hasOtherActivity = activities => (activities || []).some(activity => activity?.id === OTHER_ACTIVITY_ID)

// Activity names, the precision typed for "Autre" being appended between parentheses
export const activityNames = (activities, otherActivity) => (activities || [])
    .filter(activity => activity?.name)
    .map(activity => activity.id === OTHER_ACTIVITY_ID && otherActivity
        ? `${activity.name} (${otherActivity})`
        : activity.name
    )

export const newOrganizationTypes = [
    { id: 'association', name: 'Association' },
    { id: 'supplier', name: 'Fournisseur' },
    { id: 'partner', name: 'Partenaire' },
    { id: 'internal', name: 'Interne' }
]

export const answerOptions = [
    { id: 'yes', name: 'Oui' },
    { id: 'no', name: 'Non' },
    { id: 'idk', name: 'Je ne sais pas' }
]

export const yesNoOptions = [
    { id: 'yes', name: 'Oui' },
    { id: 'no', name: 'Non' },
]

export const animalEvaluationOptions = [
    { id: '1', name: 'Oui' },
    { id: '2', name: 'Non' },
    { id: '3', name: 'Non évaluée' },
]

export const paymentMethodOptions = [
    { id: 'bankCard', name: 'carte bancaire' },
    { id: 'check', name: 'chèque' },
    { id: 'cash', name: 'espèce' },
    { id: 'directDebit', name: 'prélèvement' },
    { id: 'transfer', name: 'virement' },
]
export const memberObjects = [
    { id: '1', name: 'P' },
    { id: '2', name: 'M' },
    { id: '3', name: 'G' }
]

export const adhesionExerciceObjects = [
    { id: 'current', name: 'Exercice en cours' },
    { id: 'previous', name: 'Exercice précédent' },
]

export const newStateObjects = [
    { id: 'active', name: 'Actif' },
    { id: 'inactive', name: 'Inactif' }
]

export const TypeOfLiberalityRecordObjects = [
    { id: 'legs', code: 'LG', name: 'Legs', fullName: 'LG - LEGS'},
    { id: 'lifeInsurance', code: 'AV', name: 'Assurance vie', fullName: 'AV - Assurance vie'},
    { id: 'donations', code: 'DO', name: 'Donations', fullName: 'DO - Donations'},
    { id: 'giftsOnInheritance', code: 'DS', name: 'Dons sur succession', fullName: 'DS - Dons sur succession'},
]

export const liberalityReversionEntryReasonObjects = [
    { id: 'deposit', name: 'Acompte' },
    { id: 'balance', name: 'Solde' },
    { id: 'funds', name: 'Fonds' },
]

export const liberalityReversionDepartureFormObjects = [
    { id: 'reversion', name: 'Versement' },
    { id: 'advanceRecovery', name: "Reprise d'avance" }
]

export const liberalityReversionDepartureStatusObjects = [
    { id: 'ongoing', name: 'En cours' },
    { id: 'awaitingPayment', name: 'En attente de versement' },
    { id: 'paid', name: 'Versé' },
    { id: 'allocated', name: 'Imputé' },
]

export const FileStatusObjects = [
    { id: 'useful', name: 'Utile'},
    { id: 'useless', name: 'Inutile'},
    { id: 'necessary', name: 'Nécessaire'}
]

export const adoptionStatusObjects = [
    { id: 'draft', name: 'Brouillon' },
    { id: 'toBePresented', name: 'À présenter' },
    { id: 'adopted', name: 'Adopté' },
]

export const maritalStatusObjects = [
    { id: 'single', name: 'Célibataire' },
    { id: 'married', name: 'Marié(e)' },
    { id: 'widowed', name: 'Veuf(ve)' },
    { id: 'divorced', name: 'Divorcé(e)' },
]

export const dependencies = [
    {
        name: 'DecisionBody',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'bureau', name: 'Bureau' },
            { id: 'boardOfDirectors', name: "Conseil d'administration" },
        ]
    },
    {
        name: 'UnitList',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'euro', name: '€' },
            { id: 'kilogram', name: 'kg'}
        ]
    },
    {
        name: 'OrganizationStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: organizationStatusObjects
    },
    {
        name: 'EstablishmentStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: establishmentStatusObjects
    },
    {
        // ids are the schema.org dayOfWeek values, exposed as is by the external API.
        name: 'OpeningDay',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'Monday', name: 'Lundi' },
            { id: 'Tuesday', name: 'Mardi' },
            { id: 'Wednesday', name: 'Mercredi' },
            { id: 'Thursday', name: 'Jeudi' },
            { id: 'Friday', name: 'Vendredi' },
            { id: 'Saturday', name: 'Samedi' },
            { id: 'Sunday', name: 'Dimanche' }
        ]
    },
    {
        name: 'YesNo',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: yesNoOptions
    },
    {
        name: 'ExerciseStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'ongoing', name: 'ongoing' },
            { id: 'provisionalClosure', name: 'provisionalClosure' },
            { id: 'finalClosure', name: 'finalClosure' }
        ]
    },
    {
      name: 'NewOrganizationActivity',
      type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: newOrganizationActivities
    },
    {
      name: 'NewOrganizationType',
      type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: newOrganizationTypes
    },
    {
        name: 'AnswerOption',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: answerOptions
    },
    {
        name: 'PaymentMethod',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: paymentMethodOptions
    },
    {
      name: 'ShelterType',
      type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: newOrganizationActivities,
        filters: [
            {
                name: "byTypes",
                isDefault: false,
                query: (context) => {
                    const types = _.get(context, 'data.types', [])
                    return types.length > 0
                        ? {id: {$in: types.map(type => type.id)}}
                        : {id: null}
                }
            },
            {
                name: "byOrganizations",
                isDefault: false,
                query: (context) => {
                    const activitiesTypes = _.get(context, 'data.activitiesTypes')
                    return activitiesTypes && activitiesTypes.length
                        ? {id: {$in: activitiesTypes.map(at => at.id)}}
                        : {id: null}
                }
            }
        ]
    },
    {
        name: 'TypeOfLiberalityFile',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'code', 'name', 'fullName'],
        objects: TypeOfLiberalityRecordObjects
    },
    {
        name: 'TypeOfLiberalityRecord',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'code', 'name', 'fullName'],
        objects: TypeOfLiberalityRecordObjects
    },
    {
        name: 'FileStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: FileStatusObjects
    },
    {
        name: 'Qualification',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'LU', name: 'LU' },
            { id: 'LTU', name: 'LTU' },
            { id: 'LP', name: 'LP' }
        ]
    },
    {
        name: 'Civility',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'm', name: 'Monsieur' },
            { id: 'mme', name: 'Madame' },
            { id: 'mlle', name: 'Mademoiselle' },
            { id: 'o', name: 'Autre' }
        ]
    },
    {
        name: 'NewCivility',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'm', name: 'monsieur' },
            { id: 'mme', name: 'madame' },
            { id: 'o', name: 'divers' }
        ]
    },
    {
        name: 'NewState',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: newStateObjects
    },
    {
        name: 'Member',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: memberObjects
    },
    {
        name: 'AdhesionExercice',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: adhesionExerciceObjects
    },
    {
        name: 'OrganizationSize',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: '1', name: 'Petite' },
            { id: '2', name: 'Moyenne' },
            { id: '3', name: 'Grande' }
        ]
    },
    {
        name: 'AnimalSize',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: '1', name: 'Petit' },
            { id: '2', name: 'Moyen' },
            { id: '3', name: 'Grand' }
        ]
    },
    {
        name: 'AnimalSex',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: '1', name: 'Femelle' },
            { id: '2', name: 'Mâle' },
        ]
    },
    {
        name: 'AnimalHome',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: '1', name: 'Refuge' },
            { id: '2', name: 'Famille d’accueil' },
        ]
    },
    {
        name: 'AnimalEvaluationOption',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: animalEvaluationOptions
    },
    {
        name: 'AgeBracket',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'junior', name: 'Junior' },
            { id: 'adult', name: 'Adulte' },
            { id: 'senior', name: 'Senior' },
        ]
    },
    {
        name: 'Action',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'validate', name: 'valider' },
            { id: 'refuse', name: 'refuser' },
            { id: 'rectify', name: 'à corriger' },
            { id: 'justify', name: 'à justifier' }
        ],
        filters: [
            {
                name: 'controlActions',
                isDefault: false,
                match: object => {
                    return ['validate', 'refuse', 'rectify'].includes(object.id)
                }
            },
            {
                name: 'validationActions',
                isDefault: false,
                match: object => {
                    return ['validate', 'refuse', 'justify'].includes(object.id)
                }
            }
        ]
    },
    {
        name: 'RefundStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'ongoing', name: 'ongoing' },
            { id: 'validated', name: 'validated' },
            { id: 'refused', name: 'refused'},
            { id: 'controlled', name: 'controlled' },
            { id: 'rectification', name: 'rectification' },
            { id: 'justification', name: 'justification' },
            { id: 'paid', name: 'paid' },
            { id: 'waiting', name: 'waiting' },
            { id: 'actualized', name: 'actualized' },
            { id: 'reallocated', name: 'reallocated' },

        ]
    },
    {
        name: 'InvoiceStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'ongoing', name: 'ongoing' },
            { id: 'controlled', name: 'controlled' },
            { id: 'validated', name: 'validated' },
            { id: 'refused', name: 'refused'},
            { id: 'justification', name: 'justification' },
            { id: 'paid', name: 'paid' },
            { id: 'waiting', name: 'waiting' },
            { id: 'actualized', name: 'actualized' }
        ]
    },
    {
        name: 'ReliefFundApplicationStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name', 'bStyle'],
        objects: refundApplicationStatusObjects
    },
    {
        name: 'ReliefFundPaymentStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name', 'bStyle'],
        objects: reliefFundPaymentStatusObjects
    },
    {
        name: 'AdhesionApplicationStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name', 'bStyle'],
        objects: adhesionApplicationStatusObjects
    },
    {
        name: 'LiberalityApplicationStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name', 'bStyle'],
        objects: liberalityApplicationStatusObjects
    },
    {
        name: 'LiberalityReversionRecordStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name', 'bStyle'],
        objects: liberalityReversionRecordStatusObjects
    },
    {
        name: 'LiberalityReceivableStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: liberalityReceivableStatusObjects
    },
    {
        name: 'LiberalitySolicitationStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: liberalitySolicitationStatusObjects
    },
    {
        name: 'LiberalityReversionEntryReason',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: liberalityReversionEntryReasonObjects
    },
    {
        name: 'LiberalityReversionDepartureForm',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: liberalityReversionDepartureFormObjects
    },
    {
        name: 'LiberalityReversionDepartureStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: liberalityReversionDepartureStatusObjects
    },
    {
        name: 'BatchStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'waiting', name: 'waiting' },
            { id: 'validated', name: 'validated' },
            { id: 'paid', name: 'paid' },
            { id: 'toPay', name: 'toPay' },
            { id: 'actualized', name: 'actualized' }
        ]
    },
    {
        name: 'PaymentStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'controlled', name: 'controlled' },
            { id: 'paid', name: 'paid' }
        ]
    },
    {
        name: 'BenefitRecipient',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'salaried', name: 'salaried' },
            { id: 'retired', name: 'retired' },
            { id: 'rightHolder', name: 'rightHolder' }
        ]
    },
    {
        name: 'Journal',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: '0000001', name: 'refund' },
            { id: '0000002', name: 'purchase' },
            { id: '0000003', name: 'sale' },
            { id: '0000004', name: 'variousOperation' }
        ]
    },
    {
        name: 'SupplierJournal',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: '0000001', name: 'bank' },
            { id: '0000002', name: 'sale' },
            { id: '0000003', name: 'purchase' }
        ]
    },
    {
        name: 'Process',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'adhesion', name: 'Adhésion' },
            { id: 'emergencyFund', name: 'Fonds de Secours Exceptionnel' },
            /*
            { id: 'refund', name: 'refundRequest' },
            { id: 'invoice', name: 'supplierInvoice' },
             */
        ]
    },
    {
        name: 'Global',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'exercise', 'code', 'name'],
        objects: [
            { id: 'global', code: 'global',  name: 'global', exercise: ''},
        ]
    },
    {
        name: 'AccountStatementReason',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'submitted', name: 'submitted' },
            { id: 'refused', name: 'refused' },
            { id: 'toRectify ', name: 'toRectify' },
        ]
    },
    {
        name: 'AccountStatementOperation',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'debit', name: 'debit' },
            { id: 'credit', name: 'credit' },
        ]
    },
    {
        name: 'Form',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'advanceOnLegacy', name: 'advanceOnLegacy' },
            { id: 'directAssociationPayment', name: 'directAssociationPayment' },
            { id: 'thirdPartyDirectPayment', name: 'thirdPartyDirectPayment' },
        ]
    },
    {
        name: 'LandType',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name', 'name2'],
        objects: [
            { id: 'rentedByTheAssociation', name: 'rentedByTheAssociation', name2: 'rentedByTheAssociation_submission' },
            { id: 'provisionOfTheAssociation', name: 'provisionOfTheAssociation', name2: 'provisionOfTheAssociation_submission' },
            { id: 'propertyOfTheAssociation', name: 'propertyOfTheAssociation', name2: 'propertyOfTheAssociation_submission' },
            { id: 'propertyOfTheCommunityOrMetropolis', name: 'propertyOfTheCommunityOrMetropolis', name2: 'propertyOfTheCommunityOrMetropolis_submission' }
        ]
    },
    {
        name: 'AnimalTypeGroup',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'domesticCarnivores', name: 'domesticCarnivores' },
            { id: 'equids', name: 'equids' },
            { id: 'farmAnimals', name: 'farmAnimals' },
            { id: 'wildlife', name: 'wildlife' }
        ]
    },
    {
        name: 'LiberalityMaritalStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: maritalStatusObjects
    },
    {
        name: 'AdoptionStatus',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: adoptionStatusObjects
    },
    {
        name: 'CompatibilityType',
        type: 'static',
        fields: [{ path: 'id', type: 'string' }, 'name'],
        objects: [
            { id: 'animal', name: 'Animaux' },
            { id: 'human', name: 'Humains' },
            { id: 'place', name: 'Lieux' },
        ]
    }
]
